"use strict";
/*
 * Created on 03 13 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var DateParser_1 = require("../../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var PriceFormulas_1 = require("../../../core/model/math/PriceFormulas");

var utils_1 = require("../../../core/utils");

var DateUtils_1 = require("../../../core/utils/DateUtils");

var ExportedPriceHistory_1 = require("../../../price-list/model/ExportedPriceHistory");

var PriceStats_1 = require("../../../price-list/model/PriceStats");

var ProductPurchasePrice_1 = require("../../../product/model/ProductPurchasePrice");

var RegularProductPrice_1 = require("../../../product/model/RegularProductPrice");

var RoundedProductPrice_1 = require("../../../product/model/RoundedProductPrice");

var VendorAllowanceBonus_1 = require("../../../vendor-allowance/model/VendorAllowanceBonus");

var FinalProductPrice_1 = require("../FinalProductPrice");

var PriceComment_1 = require("../PriceComment");

var RealImpactValue_1 = require("../RealImpactValue");
/**
 * Encapsulates prices related to single {@link SelloutReleaseItem release item} of {@link SelloutRelease sellout release}.
 *
 * @author JMe
 * @author Radek Beran
 */


var SelloutReleaseItemPrices =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseItemPrices, _DomainObject_1$Domai);

  /**
   * Creates sellout release item prices. "Old" values in impact report are values for actual selling price, "New" values are forecasted
   * for suggested final price.
   *
   * TODO JPk: firstRegularPrice is no longer needed, when storing data for all (re)opens.
   *
   * @param regularPriceNational Actual regular price (ARP) within national zone.
   * @param regularPrice actual regular price; sellout price in case of re-opened release
   * @param firstRegularPrice actual regular price valid when the release was first opened; null if release was not re-opened yet
   * @param purchasePrice actual product purchase price
   * @param vendorAllowance vendor allowance bonus for product
   * @param selloutPrice sellout price suggested by system; user cannot edit this price, it is default for final price
   * @param promoPriceStats contains some statistic about product's promo prices
   * @param priceCode price code
   * @param finalPrice final price for item re-pricing
   * @param exportedPriceHistory Wrapper of exported prices.
   * @param comments list of comments (comments on final price)
   * @param lastValidPriceValidTo The last actually valid price interval validity end as planned before automatic/manual termination (If
   *        that is the case.). Filled on price termination or expiration. For exported prices that were never valid corresponds to
   *        the first intentional validity end.
   * @param forecastOldForOneDay forecast of sold amount for old price (for actual sale price) weighted for site level and recomputed to
   *        single day. You have to multiply this value according to an application use case.
   * @param forecastNewForOneDay forecast of sold amount for new price (for final price) weighted for site level and recomputed to single
   *        day. You have to multiply this value according to an application use case.
   * @param priceElasticity computed as e = x/(x - 1.1), YDG returns x value on product and price zone level (we have to call YDG on zone)
   * @param repricingImportance
   * @param discountPercent [%] = ((actual regular price - final price) / actual regular price) * 100
   * @param marginOldUnit actual margin [CZK], for actual regular price
   * @param marginOld actual margin [CZK], for actual regular price, weighted by sold amount
   * @param marginOldPercent actual margin [%], for actual regular price, weighted by sold amount
   * @param marginNewUnit new margin [CZK], for new price
   * @param marginNew new margin [CZK], for new price, weighted by sold amount
   * @param marginNewPercent new margin [%], for new price, weighted by sold amount
   * @param marginChange margin change [CZK] = marginNew - marginOld
   * @param marginChangePercent margin change [%] = marginNewPercent - marginOldPercent
   * @param profitOldUnit profit [CZK] = regular price - purchase price
   * @param profitOld profit [CZK] = regular price - purchase price, value may be weighted by stock volume
   * @param profitOldPercent actual profit [%], for actual regular price, weighted by sold amount
   * @param profitNewUnit profit [CZK] = final price - purchase price
   * @param profitNew profit [CZK] = final price - purchase price, value may be weighted by stock volume
   * @param profitNewPercent profit [%] = (final price - purchase price) / purchase price * 100
   * @param profitImpact profit [CZK] = profitNew - profitOld
   * @param profitImpactPercent profit impact [%] = profitNewPercent - profitOldPercent
   * @param daysLeftOld days left to sell out supplies for actual selling price
   * @param daysLeftNew days left to sell out supplies for suggested final price
   * @param endDateOld date when the product should be sold out according to actual regular (selling) price
   * @param deadstockProvisionDiscountPercent % discount according to category type (settable in general settings of sellout)
   * @param deadstockProvision [CZK] = deadstock quantity * purchase price * discount in %;
   *        type of discount in % is chosen according to deadstock length; deadstock provision can be recalculated every day;
   *        if the sellout release is not approved within one day; warning with recalculation will display
   * @param deadstockInvestment investment [CZK] = (regular price - final price) * deadstock quantity
   * @param deadstockSelloutImpact [CZK] = deadstockInvestment + deadstockProvision
   * @param realImpact
   * @param salesVolumeOld (Quantity old) (time dependent) oldForecast from Yieldigo (expected regular sold amount
   *        in unit (kg, ks, ...) for current regular price, for time interval of new price validity - to be time-comparable
   *        with salesVolumeNew).
   * @param salesVolumeNew (Quantity new) (time dependent) newForecast from Yieldigo (expected sold amount
   *        in unit (kg, ks, ...) for new final price, for time interval of new price validity)
   * @param revenueOld (Sales old) (time dependent) computed as salesVolumeOld * actual regular price [CZK]
   * @param revenueNew (Sales new) (time dependent) computed as salesVolumeNew * new final price [CZK]
   */
  function SelloutReleaseItemPrices(regularPriceNational, regularPrice, firstRegularPrice, purchasePrice, vendorAllowance, selloutPrice, promoPriceStats, priceCode, finalPrice, exportedPriceHistory, comments, lastValidPriceValidTo, // Forecasts (from Yieldigo, re-computed for site level and single day)
  forecastOldForOneDay, forecastNewForOneDay, priceElasticity, repricingImportance, // Impact attributes: discount
  discountPercent, // Impact attributes: margins
  marginOldUnit, marginOld, marginOldPercent, marginNewUnit, marginNew, marginNewPercent, marginChange, marginChangePercent, // Impact attributes: profit
  profitOldUnit, profitOld, profitOldPercent, profitNewUnit, profitNew, profitNewPercent, profitImpact, profitImpactPercent, // Impact attributes: dates
  daysLeftOld, daysLeftNew, endDateOld, // Impact attributes: provision/investment
  deadstockProvisionDiscountPercent, deadstockProvision, deadstockInvestment, deadstockSelloutImpact, realImpact, // Quantity (volumes)
  salesVolumeOld, salesVolumeNew, // Sales (revenues)
  revenueOld, revenueNew) {
    var _this;

    _classCallCheck(this, SelloutReleaseItemPrices);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseItemPrices).call(this));
    _this.regularPriceNational = regularPriceNational;
    _this.regularPrice = regularPrice;
    _this.firstRegularPrice = firstRegularPrice;
    _this.purchasePrice = purchasePrice;
    _this.vendorAllowance = vendorAllowance;
    _this.selloutPrice = selloutPrice;
    _this.promoPriceStats = promoPriceStats;
    _this.priceCode = priceCode;
    _this.finalPrice = finalPrice;
    _this.exportedPriceHistory = exportedPriceHistory;
    _this.comments = comments;
    _this.lastValidPriceValidTo = lastValidPriceValidTo;
    _this.forecastOldForOneDay = forecastOldForOneDay;
    _this.forecastNewForOneDay = forecastNewForOneDay;
    _this.priceElasticity = priceElasticity;
    _this.repricingImportance = repricingImportance;
    _this.discountPercent = discountPercent;
    _this.marginOldUnit = marginOldUnit;
    _this.marginOld = marginOld;
    _this.marginOldPercent = marginOldPercent;
    _this.marginNewUnit = marginNewUnit;
    _this.marginNew = marginNew;
    _this.marginNewPercent = marginNewPercent;
    _this.marginChange = marginChange;
    _this.marginChangePercent = marginChangePercent;
    _this.profitOldUnit = profitOldUnit;
    _this.profitOld = profitOld;
    _this.profitOldPercent = profitOldPercent;
    _this.profitNewUnit = profitNewUnit;
    _this.profitNew = profitNew;
    _this.profitNewPercent = profitNewPercent;
    _this.profitImpact = profitImpact;
    _this.profitImpactPercent = profitImpactPercent;
    _this.daysLeftOld = daysLeftOld;
    _this.daysLeftNew = daysLeftNew;
    _this.endDateOld = endDateOld;
    _this.deadstockProvisionDiscountPercent = deadstockProvisionDiscountPercent;
    _this.deadstockProvision = deadstockProvision;
    _this.deadstockInvestment = deadstockInvestment;
    _this.deadstockSelloutImpact = deadstockSelloutImpact;
    _this.realImpact = realImpact;
    _this.salesVolumeOld = salesVolumeOld;
    _this.salesVolumeNew = salesVolumeNew;
    _this.revenueOld = revenueOld;
    _this.revenueNew = revenueNew;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to final price.
   */


  _createClass(SelloutReleaseItemPrices, [{
    key: "getVendorAllowancePercent",

    /**
     * Returns VA in %.
     */
    value: function getVendorAllowancePercent() {
      // LOG-5292: Using withoutBackBonus:
      return this.vendorAllowance !== null && this.vendorAllowance.withoutBackBonus !== null ? this.vendorAllowance.withoutBackBonus : null;
    }
    /**
     * Returns start date of a new (final) price. Reused in both export and reporting.
     */

  }, {
    key: "getFinalPriceFrom",
    value: function getFinalPriceFrom() {
      return this.finalPrice !== null ? this.finalPrice.validFrom : null;
    }
    /**
     * Returns last exported start date of a (final) price.
     */

  }, {
    key: "getLastExportedFinalPriceFrom",
    value: function getLastExportedFinalPriceFrom() {
      return this.finalPrice !== null ? this.finalPrice.lastExportedValidFrom : null;
    }
    /**
     * Returns last exported (final) price.
     */

  }, {
    key: "getLastExportedFinalPrice",
    value: function getLastExportedFinalPrice() {
      return this.finalPrice !== null ? this.finalPrice.lastExportedValue : null;
    }
    /**
     * Returns exported end date of new (final) price. Reused in both export and reporting.
     */

  }, {
    key: "getFinalPriceTo",
    value: function getFinalPriceTo() {
      return this.finalPrice !== null ? !utils_1.Utils.isValueMissing(this.finalPrice.validTo) ? this.finalPrice.validTo : DateUtils_1.DateUtils.DATE_TO_INFINITY : null;
    }
  }, {
    key: "isFinalPriceDifferentThanRegular",
    value: function isFinalPriceDifferentThanRegular() {
      return PriceFormulas_1.PriceFormulas.finalPriceDiffersFromRegular(this.finalPrice, this.regularPrice);
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SelloutReleaseItemPrices(mat.regularPriceNational, mat.regularPrice, mat.firstRegularPrice, mat.purchasePrice, mat.vendorAllowance, mat.selloutPrice, mat.promoPriceStats, mat.priceCode, mat.finalPrice, mat.exportedPriceHistory, mat.comments, mat.lastValidPriceValidTo, mat.forecastOldForOneDay, mat.forecastNewForOneDay, mat.priceElasticity, mat.repricingImportance, mat.discountPercent, mat.marginOldUnit, mat.marginOld, mat.marginOldPercent, mat.marginNewUnit, mat.marginNew, mat.marginNewPercent, mat.marginChange, mat.marginChangePercent, mat.profitOldUnit, mat.profitOld, mat.profitOldPercent, mat.profitNewUnit, mat.profitNew, mat.profitNewPercent, mat.profitImpact, mat.profitImpactPercent, mat.daysLeftOld, mat.daysLeftNew, mat.endDateOld, mat.deadstockProvisionDiscountPercent, mat.deadstockProvision, mat.deadstockInvestment, mat.deadstockSelloutImpact, mat.realImpact, mat.salesVolumeOld, mat.salesVolumeNew, mat.revenueOld, mat.revenueNew);
    }
  }]);

  return SelloutReleaseItemPrices;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseItemPrices = SelloutReleaseItemPrices;
SelloutReleaseItemPrices.EMPTY = new SelloutReleaseItemPrices(null, null, null, null, null, null, PriceStats_1.PriceStats.EMPTY, null, null, ExportedPriceHistory_1.ExportedPriceHistory.EMPTY, immutable_1.List.of(), null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null);

SelloutReleaseItemPrices.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SelloutReleaseItemPrices.name);
  return {
    regularPriceNational: builder.opt(builder.obj('regularPriceNational', RegularProductPrice_1.RegularProductPrice.productPriceSchema, function (mat) {
      return new RegularProductPrice_1.RegularProductPrice(mat.value, mat.valueRounded, mat.vatRate);
    })),
    regularPrice: builder.opt(builder.obj('regularPrice', RegularProductPrice_1.RegularProductPrice.productPriceSchema, function (mat) {
      return new RegularProductPrice_1.RegularProductPrice(mat.value, mat.valueRounded, mat.vatRate);
    })),
    firstRegularPrice: builder.opt(builder.obj('firstRegularPrice', RegularProductPrice_1.RegularProductPrice.productPriceSchema, function (mat) {
      return new RegularProductPrice_1.RegularProductPrice(mat.value, mat.valueRounded, mat.vatRate);
    })),
    purchasePrice: builder.opt(builder.obj('purchasePrice', ProductPurchasePrice_1.ProductPurchasePrice.schema, function (mat) {
      return ProductPurchasePrice_1.ProductPurchasePrice.fromDataDict(mat);
    })),
    vendorAllowance: builder.opt(builder.obj('vendorAllowance', VendorAllowanceBonus_1.VendorAllowanceBonus.schema, function (mat) {
      return VendorAllowanceBonus_1.VendorAllowanceBonus.fromDataDict(mat);
    })),
    selloutPrice: builder.opt(builder.obj('selloutPrice', RoundedProductPrice_1.RoundedProductPrice.roundedPriceSchema, function (mat) {
      return new RoundedProductPrice_1.RoundedProductPrice(mat.value, mat.valueRounded);
    })),
    promoPriceStats: builder.obj('promoPriceStats', PriceStats_1.PriceStats.schema, function (mat) {
      return new PriceStats_1.PriceStats(mat.currentPrices, mat.lastAmount, mat.minAmount, mat.averageAmount, mat.openingAmount);
    }),
    priceCode: builder.opt(builder.str('priceCode')),
    finalPrice: builder.opt(builder.obj('finalPrice', FinalProductPrice_1.FinalProductPrice.schema, function (mat) {
      return FinalProductPrice_1.FinalProductPrice.fromDataDict(mat);
    })),
    exportedPriceHistory: builder.obj('exportedPriceHistory', ExportedPriceHistory_1.ExportedPriceHistory.schema, function (mat) {
      return ExportedPriceHistory_1.ExportedPriceHistory.fromDataDict(mat);
    }),
    comments: builder.listOf(builder.obj('comments', PriceComment_1.PriceComment.schema, function (mat) {
      return new PriceComment_1.PriceComment(mat.id, mat.releaseId, mat.priceZoneId, mat.userId, mat.username, mat.productId, mat.text, mat.persistent, mat.deleteOn);
    })),
    lastValidPriceValidTo: builder.opt(builder.date('lastValidPriceValidTo', DateParser_1.DateParser.ISO_PATTERN)),
    forecastOldForOneDay: builder.opt(builder.bigNum('forecastOldForOneDay')),
    forecastNewForOneDay: builder.opt(builder.bigNum('forecastNewForOneDay')),
    priceElasticity: builder.opt(builder.bigNum('priceElasticity')),
    repricingImportance: builder.opt(builder.bigNum('repricingImportance')),
    discountPercent: builder.opt(builder.bigNum('discountPercent')),
    marginOldUnit: builder.opt(builder.bigNum('marginOldUnit')),
    marginOld: builder.opt(builder.bigNum('marginOld')),
    marginOldPercent: builder.opt(builder.bigNum('marginOldPercent')),
    marginNewUnit: builder.opt(builder.bigNum('marginNewUnit')),
    marginNew: builder.opt(builder.bigNum('marginNew')),
    marginNewPercent: builder.opt(builder.bigNum('marginNewPercent')),
    marginChange: builder.opt(builder.bigNum('marginChange')),
    marginChangePercent: builder.opt(builder.bigNum('marginChangePercent')),
    profitOldUnit: builder.opt(builder.bigNum('profitOldUnit')),
    profitOld: builder.opt(builder.bigNum('profitOld')),
    profitOldPercent: builder.opt(builder.bigNum('profitOldPercent')),
    profitNewUnit: builder.opt(builder.bigNum('profitNewUnit')),
    profitNew: builder.opt(builder.bigNum('profitNew')),
    profitNewPercent: builder.opt(builder.bigNum('profitNewPercent')),
    profitImpact: builder.opt(builder.bigNum('profitImpact')),
    profitImpactPercent: builder.opt(builder.bigNum('profitImpactPercent')),
    daysLeftOld: builder.opt(builder.bigNum('daysLeftOld')),
    daysLeftNew: builder.opt(builder.bigNum('daysLeftNew')),
    endDateOld: builder.opt(builder.date('endDateOld', DateParser_1.DateParser.ISO_PATTERN)),
    deadstockProvisionDiscountPercent: builder.opt(builder.bigNum('deadstockProvisionDiscountPercent')),
    deadstockProvision: builder.opt(builder.bigNum('deadstockProvision')),
    deadstockInvestment: builder.opt(builder.bigNum('deadstockInvestment')),
    deadstockSelloutImpact: builder.opt(builder.bigNum('deadstockSelloutImpact')),
    realImpact: builder.opt(builder.obj('realImpact', RealImpactValue_1.RealImpactValue.schema, RealImpactValue_1.RealImpactValue.ctor)),
    salesVolumeOld: builder.opt(builder.bigNum('salesVolumeOld')),
    salesVolumeNew: builder.opt(builder.bigNum('salesVolumeNew')),
    revenueOld: builder.opt(builder.bigNum('revenueOld')),
    revenueNew: builder.opt(builder.bigNum('revenueNew'))
  };
}();